import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import Keycloak from 'keycloak-js';
import { Role, RoleService } from '@/services/role.service';

@Component({
    selector: 'cnf-access-denied',
    standalone: true,
    imports: [RouterModule, ButtonModule],
    template: `
        <div class="min-h-screen flex justify-center items-center px-8 bg-surface-50 dark:bg-surface-950">
            <div class="card text-center flex flex-col items-center gap-4 max-w-md">
                <i class="pi pi-lock text-primary" style="font-size: 3rem"></i>
                <div class="font-semibold text-2xl">Kein Zugriff</div>
                <p class="m-0 text-surface-500 dark:text-surface-400">Ihnen fehlt die Berechtigung für diese Seite. Wenden Sie sich bei Bedarf an einen Administrator.</p>
                <div class="flex gap-2">
                    <p-button label="Abmelden" icon="pi pi-sign-out" severity="danger" [outlined]="true" (onClick)="logout()" />
                    @if (canAccess) {
                        <p-button label="Zur Startseite" icon="pi pi-home" [routerLink]="['/']" />
                    }
                </div>
            </div>
        </div>
    `
})
export class AccessDenied {
    private readonly keycloak = inject(Keycloak);
    readonly canAccess = inject(RoleService).hasRole(Role.Access);

    logout() {
        this.keycloak.logout({ redirectUri: window.location.origin });
    }
}
